//@flow
import React from "react"
import { Field, reduxForm } from "redux-form"
import {
  InputField,
  Label,
  FormGroup,
  Error,
  FieldHeading,
  FormRow,
  FormCol,
  Note
} from "../UI/Form"
import FileUploader from "../UI/FileUploader"
import { PrimaryButton, SecondaryButton, DangerButton } from "../UI/Buttons"
import validate from "./validate"
import type { SlideFormProps } from "./types"

const validateFile = (file, index) => index === 0 && /^image\//.test(file.type)

class SlideForm extends React.Component<SlideFormProps> {
  componentDidUpdate(prevProps) {
    const { change, assetId } = this.props
    if (prevProps.assetId !== assetId) {
      change("assetId", assetId)
    }
  }

  render() {
    const {
      handleSubmit,
      handleCancel,
      handleChange,
      handleDelete,
      error,
      isNew,
      pristine,
      onFileDrop,
      uploading,
      uploadErrorMessage,
      existingAssetURL
    } = this.props
    return (
      <form onSubmit={handleSubmit}>
        <Note>Note: All fields REQUIRED</Note>

        <FormRow>
          <FormCol grow={2}>
            <FormGroup>
              <Label htmlFor="title">Title</Label>
              <Field
                name="title"
                component={InputField}
                type="text"
                onChange={handleChange}
              />
            </FormGroup>
          </FormCol>
          <FormCol grow={1}>
            <Note>This is the title for the slide.</Note>
          </FormCol>
        </FormRow>
        <FormRow>
          <FormCol grow={2}>
            <FieldHeading>Headline</FieldHeading>
            <FormRow>
              <FormCol grow={1}>
                <FormGroup>
                  <Label htmlFor="localizedHeadlineText.en">
                    <span role="img" aria-label="English">
                      🇺🇸
                    </span>{" "}
                    English
                  </Label>
                  <Field
                    name="localizedHeadlineText.en"
                    component={InputField}
                    type="text"
                    onChange={handleChange}
                  />
                </FormGroup>
              </FormCol>
              <FormCol grow={1}>
                <FormGroup>
                  <Label htmlFor="localizedHeadlineText.es">
                    <span role="img" aria-label="Spanish">
                      🇲🇽
                    </span>{" "}
                    Spanish
                  </Label>
                  <Field
                    name="localizedHeadlineText.es"
                    component={InputField}
                    type="text"
                    onChange={handleChange}
                  />
                </FormGroup>
              </FormCol>
            </FormRow>
          </FormCol>
          <FormCol grow={1}>
            <Note>This is the headline displayed on the slide.</Note>
          </FormCol>
        </FormRow>

        <FormRow>
          <FormCol grow={2}>
            <FieldHeading>Secondary Text</FieldHeading>
            <FormRow>
              <FormCol grow={1}>
                <FormGroup>
                  <Label htmlFor="localizedSecondaryText.en">
                    <span role="img" aria-label="English">
                      🇺🇸
                    </span>{" "}
                    English
                  </Label>
                  <Field
                    name="localizedSecondaryText.en"
                    component={InputField}
                    type="text"
                    onChange={handleChange}
                  />
                </FormGroup>
              </FormCol>
              <FormCol grow={1}>
                <FormGroup>
                  <Label htmlFor="localizedSecondaryText.es">
                    <span role="img" aria-label="Spanish">
                      🇲🇽
                    </span>{" "}
                    Spanish
                  </Label>
                  <Field
                    name="localizedSecondaryText.es"
                    component={InputField}
                    type="text"
                    onChange={handleChange}
                  />
                </FormGroup>
              </FormCol>
            </FormRow>
          </FormCol>
          <FormCol grow={1}>
            <Note>
              This is the secondary text displayed below the headline for the
              slide.
            </Note>
          </FormCol>
        </FormRow>

        <FormRow>
          <FormCol grow={2}>
            <FormGroup>
              <Label htmlFor="assetId">Media</Label>
              <Field
                name="assetId"
                component={InputField}
                type="hidden"
                onChange={handleChange}
              />
              <FileUploader
                validate={validateFile}
                onDrop={onFileDrop}
                generatePreviews={true}
                loading={uploading}
                errorMessage={uploadErrorMessage}
                existingAssetURL={existingAssetURL}
              />
            </FormGroup>
          </FormCol>
          <FormCol grow={1}>
            <Note>
              This is the media that will be displayed behing the text content
              for the slide.
            </Note>
          </FormCol>
        </FormRow>

        {error && <Error>{error}</Error>}

        <FormRow>
          <FormCol grow={2}>
            <FormRow>
              <FormCol grow={1} />
              <FormCol grow={1}>
                <SecondaryButton block={true} onClick={handleCancel}>
                  Cancel
                </SecondaryButton>
              </FormCol>
              <FormCol grow={1}>
                <PrimaryButton block={true} disabled={!isNew && pristine}>
                  {isNew ? "Create" : "Update"} Slide
                </PrimaryButton>
              </FormCol>
            </FormRow>
          </FormCol>
          <FormCol grow={1}>
            <Note />
          </FormCol>
        </FormRow>
        {isNew ? (
          ""
        ) : (
          <div>
            <FormRow>
              <FormCol grow={2}>
                <FormRow>
                  <FormCol grow={1} />
                  <FormCol grow={1} />
                  <FormCol grow={1}>
                    <DangerButton block={true} onClick={handleDelete}>
                      Delete Slide
                    </DangerButton>
                  </FormCol>
                </FormRow>
              </FormCol>
              <FormCol grow={1}>
                <Note>This cannot be undone.</Note>
              </FormCol>
            </FormRow>
          </div>
        )}
      </form>
    )
  }
}

export default reduxForm({
  form: "slide",
  enableReinitialize: true,
  validate
})(SlideForm)



// WEBPACK FOOTER //
// ./src/Slides/SlideForm.js